import React from 'react';
import './Setup.css';
import setupArt from '../media/setup_art.jpg';

const Setup: React.FC = () => {
  return (
    <div className="setup page-container">
      <div className="page-image-column">
        <img src={setupArt} alt="Setup" />
      </div>
      <div className="page-content-column">
       
        <div className="setup-item">
          <h3>DJ SET ONLY</h3>
          <p>ENQUIRE ON HOURLY RATE</p>
        </div>
        
        <div className="setup-item">
          <h3>MOBILE/EVENT DJ SET UP</h3>
          <p>
            DJ BOOTH<br />
            WIRED MIC<br />
            TURNTABLES OR CONTROLLER<br />
            10" 300W SPEAKERS<br />
            12" 500W SUBWOOFERS<br />
            (INC. DJ SET)
          </p>
        </div>
        
        <div className="setup-item">
          <h3>SOUND TRIGGERED LIGHTING SET UP</h3>
          <p>
            PARS<br />
            RGBAW+U COLOR RANGE
          </p>
        </div>
        
        <div className="setup-item">
          <h3>DMX LIGHTING SET UP</h3>
          <p>
            PARS/LEDS/LAZER<br />
            GOBO MOVING HEADS<br />
            RGBAW+U COLOR RANGE
          </p>
        </div>
        
        <div className="setup-item">
          <h3>UPLIGHTING SET UP</h3>
          <p>
            RGBAW+U COLOR RANGE<br />
            DMX CONTROLLED
          </p>
        </div>
        
        <div className="setup-item">
          <h3>SET UP/TEAR DOWN</h3>
          <p>ENQUIRE ON HOURLY RATE</p>
        </div>
        
        <div className="setup-note">
          <p>ALL AUDIO SETUPS COMPATIBLE WITH THE MAJORITY OF PA OR INHOUSE AUDIO SYSTEMS</p>
        </div>
      </div>
    </div>
  );
};

export default Setup;
